import MainLayout from "../components/SharedComponents/MainLayout";
import HeroSection from "../components/AtelierPageComponents/HeroSection";
import WorkshopSection from "../components/AtelierPageComponents/WorkshopSection";
import FormSection from "../components/AtelierPageComponents/FormSection";

export default function AtelierPage() {
    return (
      <div>
        <MainLayout>
          <HeroSection />
          <WorkshopSection />
          <FormSection />
        </MainLayout>
      </div>
    );
  }
  
